import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect, useSelector } from 'react-redux';
import { getCodes } from "./../actions/codes";
import Button from '@material-ui/core/Button';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
  } from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab } from '@material-ui/core';
// import ReactExport from "react-export-excel";
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'

import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import { makeStyles } from '@material-ui/core/styles';
import { sendMobile } from '../functions/mobile';
import { consolidateMovementsReport } from '../functions/movements-report';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'
moment.locale("en");

const useStyles = makeStyles(theme => ({
    valuepositive : {
        color : 'black'
    },
    valuenegative : {
        color : '#dc3545'
    }
}));

// const ExcelFile = ReactExport.ExcelFile;
// const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
// const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const MovementsContainer = props => {

    const classesdefault = useStyles();
    const company  = useSelector(state => state.company)

    const { classes, secuencial } = props;
    const [ codespaginate, setCodesPaginate ] = useState([])
    const [ codes, setCodes ] = useState([])
    const [ page, setPage ] = useState(1)
    const [ count, setCount ] = useState(1)
    // const [ secuencialAccount, setSecuencialAccount ] = useState(secuencial)
    const [ loading, setLoading ] = useState(false)
    const [ dateStart, setDateStart ] = useState(new Date(moment().startOf('month')))
    const [ dateEnd, setDateEnd ] = useState(new Date(moment().endOf('month')))
    const [ dateValue, setDateValue ] = useState(JSON.stringify({month: moment().month(), year: moment().year()}))

    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')
            // console.log('match', secuencial)

            handleGetDataMovementsBySecuencialAccount(dateStart, dateEnd, secuencial)
            
        }
        return unmount()
    }

    useEffect(mount, []) 

    const handleGetDataMovementsBySecuencialAccount = (valueDateStart, valueDateEnd, secuencial) => {

        setLoading(true)
        setDateStart(valueDateStart)
        getCodes(valueDateStart, valueDateEnd, secuencial).payload.then(response => {
            //console.log(response);
            setCodes(response.data.MovimientosCuenta);
            getDataViewTable(response.data.MovimientosCuenta)
            setLoading(false)
        }).catch(error => {
            setLoading(false)
            setCodes([]);
            getDataViewTable([])
            //console.log(error);
        })
    }

    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEnd(date)
    }

    const onChangePaginationCodes = (e, page) => {
        let init = (page - 1) * 5;
        let end = page * 5;
        let datacodespaginate = [];
        datacodespaginate = codes.slice(init, end);
        setCodesPaginate(datacodespaginate)
        setPage(page)
    }

    
    const getDataViewTable = (codes) => {
        let datacodespaginate = [];
        let count = parseInt((codes.length / 5).toString());
        let residuo = codes.length % 5;

        if(residuo > 0){
            count++;
        }

        if(codes.length > 0){
            datacodespaginate = codes.slice(0, 5);
        }
        setCodesPaginate(datacodespaginate)
        setCount(count)
        setPage(1)
    }

    //handle
    const handleSelectCode = (val) => {
        //console.log(val)
        setDateValue(val)
        setLoading(true)
        if (val === 'Todos los movimientos') {
            setLoading(false)
            setCodes(codes)
            getDataViewTable(codes);
        } else {
            let obj = JSON.parse(val)
            // console.log('busca mes', obj.month)

                let selectMonth = new Date(obj.year, obj.month, 1)
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEnd(moment(selectMonth).endOf('month'))
                let valueStart = moment(selectMonth).startOf('month');
                let valueEnd = moment(selectMonth).endOf('month');
                handleGetDataMovementsBySecuencialAccount(valueStart, valueEnd, secuencial)
                setDateValue(val)
                //setLoading(false)
                // getDataViewTable(props.codes)
        }
        
    }

    const loadImageAsBase64 = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();

        return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
        });
    };


    const generarPDF = async () => {
        const doc = new jsPDF();

        // Cargar imagen desde PUBLIC_URL
        const logoUrl = process.env.PUBLIC_URL + '/images/logo_caja.png';
        const logoBase64 = await loadImageAsBase64(logoUrl);

        // Insertar imagen en la esquina superior derecha
        // const pageWidth = doc.internal.pageSize.getWidth();
        const imgWidth = 60; // Ajusta según el tamaño de tu imagen
        const imgHeight = 20;

        doc.addImage(logoBase64, 'PNG', 15, 10, imgWidth, imgHeight);

        doc.setFontSize(16);
        doc.text('Reporte de movimientos de cuenta', 60, 40);
        doc.setFontSize(10);
        doc.text(`Empresa: ${company[0].name}`, 15, 50);
        doc.text(`Cuenta #: ${secuencial}`, 15, 55);
        doc.text(`Desde: ${moment(dateStart).format('DD/MM/YYYY')}`, 75, 55);
        doc.text(`Generado: ${moment().format('DD/MM/YYYY HH:mm:ss')}`, 130, 55);

        const headers = [
        ['Fecha', 'Transaccion', 'Valor', 'Saldo', 'Concepto', 'Causal', 'Oficina', 'Usuario', 'Canal']
        ];

        const rows = codes.map(m => [
        moment(m.Fecha).format('DD/MM/YYYY HH:mm'),
        m.Transaccion,
        `$${m.Valor.toFixed(2)}`,
        `$${m.Saldo.toFixed(2)}`,
        m.Concepto,
        m.Causal,
        m.Oficina,
        m.Usuario,
        m.Canal
        ]);

        autoTable(doc, {
        head: headers,
        body: rows,
        startY: 60,
        styles: { fontSize: 8 },
        headStyles: {
            fillColor: [0, 151, 160],
            textColor: [255, 255, 255],
            fontStyle: "bold",
            halign: "center",
        },
        });

        // 👉 Abrir PDF en nueva pestaña
        const pdfBlobUrl = doc.output('bloburl');
        window.open(pdfBlobUrl, '_blank');
    };
    
    const handleFindRange = () => {
        
        //setLoading(true)
        handleGetDataMovementsBySecuencialAccount(dateStart, dateEnd, secuencial)
        
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (codespaginate.length > 0) {
                return  <div className = { "container" }>
                        <Grid item xs={12} md={12} lg = {12}>
                            {
                                (localStorage.caja_app !== undefined) ?
                                <Button style= {{
                                    fontSize: '60%',
                                    color: '#1a1919',
                                    borderLeft: '3px solid rgba(255, 198, 0)',
                                    backgroundColor: "white",
                                    borderRadius: '0px',
                                    fontFamily: 'Ubuntu',
                                    fontWeight: 'bold'
                                }}   onClick = {() => { 
                                    let send = {
                                        type: 'action',
                                        action: 'export_movements_excel',
                                        data: `{"dateStart":"${moment(dateStart).format('YYYY-MM-DD')}","dateEnd": "${moment(dateEnd).format('YYYY-MM-DD')}", "secuencial":"${secuencial}"}`
                                    }
                                    sendMobile(JSON.stringify(send))
                                }} >Exportar a Excel</Button>
                                :
                                // <ExcelFile element={<Button size = { "large"} variant="contained" >Exportar a Excel</Button>} filename = {"Movimientos de Cuenta"}>
                                //     <ExcelSheet data={codes} name="Movimientos">
                                //         <ExcelColumn label="Fecha" value="FechaMaquina"/>
                                //         <ExcelColumn label="Tipo" value="Transaccion"/>
                                //         <ExcelColumn label="Concepto" value="Concepto"/>
                                //         <ExcelColumn label="Valor" value="Valor"/>
                                //         <ExcelColumn label="Saldo" value="Saldo"/>
                                //     </ExcelSheet>
                                    
                                // </ExcelFile>
                                <Button
                                color="primary"
                                variant="contained"
                                onClick={ async() => await consolidateMovementsReport(codes) } >
                                    Exportar a Excel
                            </Button>
                            }
                            <Button
                                variant="contained"
                                color='secondary'
                                endIcon={<Icon>download</Icon>}
                                onClick={generarPDF}
                                style={{
                                    marginLeft: 16
                                }}
                                >
                                Exportar a PDF
                            </Button>

                        </Grid>
                        <br />
                        <br />
                        
                        <Grid item xs={12} md={12} lg = {12}>
    
                            <Table className = {"table"}>
                                <Thead>
                                    <Tr>
                                        <Th className = { "colunmvalue" }>Fecha</Th>
                                        {/* <Th># Documento</Th> */}
                                        <Th>Tipo</Th>
                                        <Th>Concepto</Th>
                                        <Th className = { "colunmvalue" }>Valor</Th>
                                        <Th className = { "colunmvalue"}>Saldo</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    { 
                                        
                                        codespaginate.map(row => (
                                            <Tr key={`${row.Documento}-${row.Fecha}`}>
                                                <Td>{ row.FechaMaquina }</Td>
                                                {/* <Td>{row.Documento}</Td> */}
                                                <Td>{row.Transaccion}</Td>
                                                <Td>{row.Concepto}</Td>
                                                <Td className = { (row.Valor >= 0) ? classesdefault.valuepositive : classesdefault.valuenegative}>$ {row.Valor}</Td>
                                                <Td>$ {row.Saldo}</Td>
                                            </Tr>
                                        ))
                                        
                                    }
                                    
                                </Tbody>
                            </Table>
                        </Grid>
                            <br/>
                            <Pagination 
                                count = { count } 
                                color = "primary" 
                                page = { page }
                                onChange = { onChangePaginationCodes }
                            />
                        </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }
    const renderBody = () => {
        return  <div>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={8} lg = {8} sm = {12}>
                            <Title>Detalle de movimientos de la Cuenta </Title>
                        </Grid>
                        <Grid item xs={12} md={4} lg = {4} sm = {12}>
                            
                        </Grid>
                    </Grid>
                    <SelectForm
                        name = { 'Período' }
                        label = { 'Seleccione período '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectCode(val)}
                        //onSubmit={ handleSubmit }
                    ></SelectForm>
                    <br></br>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container justify="center" spacing={3}  alignItems="flex-end">
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                    
                                        <KeyboardDatePicker
                                            // disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-start"
                                            label="Fecha de inicio"
                                            value={dateStart}
                                            onChange={handleDateStart}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={4} sm={12} xs={12}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                        <KeyboardDatePicker
                                            // disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-end"
                                            label="Fecha de fin"
                                            value={dateEnd}
                                            onChange={handleDateEnd}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" style= {{ backgroundColor:'#00a0af'}} aria-label="add" onClick = { handleFindRange } >
                                        <Icon>search</Icon>
                                    </Fab>
                                </Grid>
                                <Grid item md={2} sm={6} xs={6}>
                                    <Fab color="primary" aria-label="add" onClick = { () => history.push('/')} >
                                        <Icon>close</Icon>
                                    </Fab>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <br/> <br/>
                    <Grid container justify="center" spacing={3}  alignItems="center">
                        {
                            renderTableMovements()
                        }
                    </Grid>
                </div>
    }
    return (
        
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
        </div>
    );
};

MovementsContainer.propTypes = {
    secuencial: PropTypes.string.isRequired,
};

export default connect(null , { getCodes })(MovementsContainer);
// export default MovementsContainer;